module.exports = __webpack_public_path__ + "static/media/logo-icon.3b6f40c6.svg";